import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-arrow-left",
  "use": "circle-arrow-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"circle-arrow-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.5 15a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm0-1a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM8 4c.354.354.004.707 0 .707L6 7h5.5s.5 0 .5.5-.5.5-.5.5H6l2 2.292s0 .002.003.005c.037.042.327.373-.003.703-.354.354-.708 0-.708 0L4 7.5 7.293 4s.353-.354.707 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol